import { connect } from 'react-redux';
import Kerberos from './Kerberos';
import { actions } from './actions';

function mapStateToProps(state) {
  return {
    redirectTo: state.auth.redirectTo,
    loginStatus: state.login.loginStatus,
    invalidLicense: state.login.invalidLicense,
    msg: state.login.msg
  };
}
function mapDispatchToProps(dispatch) {
  return {
    postLogin: () => dispatch(actions.postLogin()),
    clearLoginStatus: () => dispatch(actions.clearLoginStatus())
  };
}

const KerberosContainer = connect(mapStateToProps, mapDispatchToProps)(Kerberos);

const route = {
  path: '/kerberos-login',
  component: KerberosContainer
};

export default KerberosContainer;
export { route, mapStateToProps, mapDispatchToProps, KerberosContainer as Kerberos };